// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dataPanelWrapper {
  top: 50%;
  right: 16px;
  width: 250px;
  height: 280px;
  padding: 0;
  position: absolute;
  transform: translateY(-50%);
  box-shadow: none !important;
  transition: all 0.2s ease;
  border-radius: 10px;
  background-color: white;
  z-index: 19;
}
.dataPanelWrapper .dataPanelContainer {
  padding: 10px 16px 24px 16px;
}
.dataPanelWrapper .dataPanelContainer .dataPanelTitle {
  flex-direction: row;
  justify-content: space-between;
}
.dataPanelWrapper .dataPanelContainer .dataPanelTitle div {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 20px;
}
.dataPanelWrapper .dataPanelContainer .dataPanelTitle .dataPanelTitleLine {
  border: none;
  height: 1px;
  margin: 0;
  flex-shrink: 0;
  background-color: rgba(0, 0, 0, 0.12);
}
.dataPanelWrapper .dataPanelContainer .dataPanel {
  font-size: small;
  margin-top: 0px;
  padding-left: 0;
  margin-bottom: 0;
  padding-bottom: 0;
  list-style-type: none;
}
.dataPanelWrapper .dataPanelContainer .dataPanel .rowData {
  display: flex;
  padding-bottom: 16px;
  justify-content: space-between;
}
.dataPanelWrapper .dataPanelContainer .dataPanel .rowData:nth-of-type(1) {
  font-size: 13px;
}
.dataPanelWrapper .dataPanelContainer .dataPanel .ant-input {
  position: relative;
  z-index: 12;
  height: 18px;
  width: 50px;
  padding: 0;
  font-size: 14px;
  text-align: right;
  padding-right: 5px;
  font-weight: 600;
}
.dataPanelWrapper .dataPanelContainer .dataPanel .button {
  position: relative;
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 1px solid lightgray;
  text-align: center;
  vertical-align: center;
  line-height: 12px;
  cursor: pointer;
}
.dataPanelWrapper .dataPanelContainer .dataPanel .button span {
  font-size: 16px;
}
.dataPanelWrapper .dataPanelContainer .dataPanel .subtract {
  border-right: none;
  border-radius: 4px 0 0 4px;
  left: 1px;
}
.dataPanelWrapper .dataPanelContainer .dataPanel .plus {
  right: 1px;
  border-left: none;
  border-radius: 0 4px 4px 0;
}
.dataPanelPopover .ant-popover-content {
  top: 30px;
  right: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/View/Option/Components/DataPanel/index.less"],"names":[],"mappings":"AAAA;EACE,QAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,2BAAA;EACA,2BAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AACF;AAbA;EAeI,4BAAA;AACJ;AAhBA;EAmBM,mBAAA;EACA,8BAAA;AAAN;AApBA;EAuBQ,eAAA;EACA,gBAAA;EACA,mBAAA;AAAR;AAzBA;EA6BQ,YAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,qCAAA;AADR;AAhCA;EAsCM,gBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AAHN;AAxCA;EA8CQ,aAAA;EACA,oBAAA;EACA,8BAAA;AAHR;AAKQ;EACE,eAAA;AAHV;AAhDA;EAyDQ,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AANR;AA3DA;EAqEQ,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;AAPR;AAtEA;EAgFU,eAAA;AAPV;AAzEA;EAqFQ,kBAAA;EACA,0BAAA;EACA,SAAA;AATR;AA9EA;EA2FQ,UAAA;EACA,iBAAA;EACA,0BAAA;AAVR;AAiBA;EAEI,SAAA;EACA,WAAA;AAhBJ","sourcesContent":[".dataPanelWrapper {\n  top: 50%;\n  right: 16px;\n  width: 250px;\n  height: 280px;\n  padding: 0;\n  position: absolute;\n  transform: translateY(-50%);\n  box-shadow: none !important;\n  transition: all .2s ease;\n  border-radius: 10px;\n  background-color: white;\n  z-index: 19;\n\n  .dataPanelContainer {\n    padding: 10px 16px 24px 16px;\n\n    .dataPanelTitle {\n      //display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n\n      div {\n        font-size: 16px;\n        font-weight: 500;\n        margin-bottom: 20px;\n      }\n\n      .dataPanelTitleLine {\n        border: none;\n        height: 1px;\n        margin: 0;\n        flex-shrink: 0;\n        background-color: rgba(0, 0, 0, 0.12);\n      }\n    }\n\n    .dataPanel {\n      font-size: small;\n      margin-top: 0px;\n      padding-left: 0;\n      margin-bottom: 0;\n      padding-bottom: 0;\n      list-style-type: none;\n\n      .rowData {\n        display: flex;\n        padding-bottom: 16px;\n        justify-content: space-between;\n\n        &:nth-of-type(1) {\n          font-size: 13px;\n        }\n\n      }\n\n      .ant-input {\n        position: relative;\n        z-index: 12;\n        height: 18px;\n        width: 50px;\n        padding: 0;\n        font-size: 14px;\n        text-align: right;\n        padding-right: 5px;\n        font-weight: 600;\n      }\n\n      .button {\n        position: relative;\n        display: inline-block;\n        width: 18px;\n        height: 18px;\n        border: 1px solid lightgray;\n        text-align: center;\n        vertical-align: center;\n        line-height: 12px;\n        cursor: pointer;\n\n        span {\n          font-size: 16px;\n        }\n      }\n\n      .subtract {\n        border-right: none;\n        border-radius: 4px 0 0 4px;\n        left: 1px;\n      }\n\n      .plus {\n        right: 1px;\n        border-left: none;\n        border-radius: 0 4px 4px 0;\n      }\n    }\n  }\n\n\n}\n.dataPanelPopover {\n  .ant-popover-content {\n    top: 30px;\n    right: 20px;\n  }\n}\n\n@primary-color: black;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
